import React, { useEffect, useState } from "react";

export default function ImageCarousel({ images = [], height = 220 }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!images.length) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 5000); // 3 sec

    return () => clearInterval(interval);
  }, [images]);

  if (!images.length) {
    return (
      <div
        className="d-flex align-items-center justify-content-center bg-light"
        style={{ height }}
      >
        No Image
      </div>
    );
  }

  return (
    <div
      className="position-relative overflow-hidden rounded"
      style={{ height }}
    >
      <img
        src={images[index]}
        alt="product"
        className="w-100 h-100 object-fit-cover transition-all"
      />

      {/* dots */}
      <div className="position-absolute bottom-0 start-50 translate-middle-x mb-2 d-flex gap-2">
        {images.map((_, i) => (
          <div
            key={i}
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: i === index ? "#fff" : "rgba(255,255,255,0.5)",
            }}
          />
        ))}
      </div>
    </div>
  );
}
